module.exports = __webpack_public_path__ + "static/media/Tasting_Sheet.1eaca5ac.pdf";